import {
  EditBlockTextInput,
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockSwitch,
  EditBlockNumericInput,
  EditBlockSliderInput,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'
import { surveyAnswerDefaultTemplate as surveyAnswer } from '@components/Widgets/_contentItems/Survey/template'
import uid from '@components/mixins/uid'

export default {
  name: 'SurveyEditorComponent',
  mixins: [genericContentItemEditor, uid],
  components: {
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-select': EditBlockSelect,
    'edit-block-switch': EditBlockSwitch,
    'edit-block-numeric-input': EditBlockNumericInput,
    'edit-block-slider-input': EditBlockSliderInput,
  },
  data() {
    return {
      currentOptions: JSON.parse(JSON.stringify(this.component.content.options)),
    }
  },
  computed: {
    surveyPlaceholderText: {
      get() {
        return this.component.content.placeholder
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['content'],
          attribute: ['placeholder'],
          data: value,
        })
      },
    },
    //= ============== STYLING
    surveyFontFamily: {
      get() {
        return this.component.styling.fontFamily
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontFamily'],
          data: value,
        })
      },
    },
    surveyFontColor: {
      get() {
        return this.component.styling.color
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['color'],
          data: value,
        })
      },
    },
    surveyBackgroundColor: {
      get() {
        return this.component.styling.backgroundColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['backgroundColor'],
          data: value,
        })
      },
    },
    surveyBorderWidth: {
      get() {
        // Removes 'px' from string
        return parseInt(this.component.styling.borderWidth, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderWidth'],
          data: value + 'px',
        })
      },
    },
    surveyBorderRadius: {
      get() {
        return parseInt(this.component.styling.borderRadius, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderRadius'],
          data: value + 'px',
        })
      },
    },
    surveyBorderColor: {
      get() {
        return this.component.styling.borderColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderColor'],
          data: value,
        })
      },
    },
    surveyFontSize: {
      get() {
        return this.component.styling.fontSize
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontSize'],
          data: value,
        })
      },
    },
    surveyTextAlign: {
      get() {
        return this.component.styling.textAlign
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['textAlign'],
          data: value,
        })
      },
    },
    //= ============== SETTINGS
    surveyLabel: {
      get() {
        return this.component.settings.label
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['label'],
          data: value,
        })
      },
    },
    surveyRequired: {
      get() {
        return this.component.settings.required
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['required'],
          data: value,
        })
      },
    },
  },
  watch: {
    currentOptions: {
      handler: function(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['content'],
          attribute: ['options'],
          data: JSON.parse(JSON.stringify(value)),
        })
      },
      deep: true,
    },
  },
  methods: {
    addOption() {
      const newOption = JSON.parse(JSON.stringify(surveyAnswer))
      newOption.id = this.getUID()
      newOption.text = newOption.text + ' ' + (this.currentOptions.length + 1)
      this.currentOptions.push(newOption)
    },
    removeOption(index) {
      this.currentOptions.splice(index, 1)
    },
  },
}
